import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export type BadgeTone = 'default' | 'success' | 'warning' | 'destructive' | 'muted'

const toneClasses: Record<BadgeTone, string> = {
  default: 'bg-primary/10 text-primary',
  success: 'bg-green-600/10 text-green-600',
  warning: 'bg-yellow-600/10 text-yellow-600',
  destructive: 'bg-destructive/10 text-destructive',
  muted: 'bg-muted text-muted-foreground',
}

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
}

/**
 * Acl.tsx の accessTone()/accessLabel() で使われているトーン表現
 * （success=green-600 / warning=yellow-600 / muted=text-muted-foreground）
 * を再利用可能な pill バッジとして抽出したもの。
 */
export function Badge({ tone = 'default', className, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        toneClasses[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}
